import checkrAnalytics, {
  getEventPropertiesFromStore,
  getUserPropertiesFromStore,
} from '../lib/analytics';
import { AMPLITUDE_ENABLED } from '../constants';

export const trackAnalyticsEvent =
  (eventTitle, eventProperties = {}) =>
  (_dispatch, getState) => {
    if (!AMPLITUDE_ENABLED) {
      return;
    }

    const eventPropertiesFromStore = getEventPropertiesFromStore(
      eventTitle,
      getState(),
    );
    try {
      return checkrAnalytics.track(
        {},
        eventTitle,
        {
          ...eventPropertiesFromStore,
          ...eventProperties,
        },
        getUserPropertiesFromStore(eventTitle, getState()),
      );
    } catch {
      // eslint-disable-next-line no-console
      return console.log('Analytics disabled due to cookies disabled.');
    }
  };

export default { trackAnalyticsEvent };
